import { Component, EventEmitter, Inject, OnInit } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Toast } from "src/app/ui/components/toast/toast";
import { AddIndustryProductDiscount } from "src/app/ui/models/domains/pbm/industry/add-industry-product-discount.model";
import { RoutePath } from "src/app/ui/models/domains/route-paths.model";
import { LoadingService } from "src/app/ui/services/loading.service";
import { IndustryDiscountsService } from "src/app/ui/services/pbm/industry-discounts.service";
import { ConfirmDialog } from "../../../shared/dialogs/confirm-dialog/confirm-dialog.component";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "add-lpm-product-dialog",
  templateUrl: "./add-lpm-product-dialog.component.html",
  styleUrls: ["./add-lpm-product-dialog.component.scss"],
})
export class AddLpmProductDialogComponent implements OnInit {
  public addInsdustryProductDialogEvent = new EventEmitter();
  public productFormGroup: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingService: LoadingService,
    private toast: Toast,
    private industryDiscountsService: IndustryDiscountsService,
    private router: Router,
    public dialogRef: MatDialogRef<ConfirmDialog>,
    @Inject(MAT_DIALOG_DATA) public data: string,
  ) {}

  ngOnInit() {
    this.productFormGroup = this.formBuilder.group({
      ean: new UntypedFormControl("", Validators.compose([Validators.required])),
      userDiscount: new UntypedFormControl("", Validators.compose([Validators.required])),
      directDiscount: new UntypedFormControl("", Validators.compose([Validators.required])),
      indirectDiscount: new UntypedFormControl("", Validators.compose([Validators.required])),
    });
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public emitAddIndustryProductEvent(addIndustryProductDiscount: AddIndustryProductDiscount) {
    this.addInsdustryProductDialogEvent.emit(addIndustryProductDiscount);
    this.closeDialog();
  }

  public async addProduct(): Promise<void> {
    const loadingRef = this.loadingService.beginLoading();

    try {
      const ean = this.productFormGroup.value.ean;
      const userDiscount = this.productFormGroup.value.userDiscount;
      const directDiscount = this.productFormGroup.value.directDiscount;
      const indirectDiscount = this.productFormGroup.value.indirectDiscount;

      if (this.productFormGroup.valid) {
        const addIndustryProductDiscount = new AddIndustryProductDiscount();
        addIndustryProductDiscount.setIndustryDiscountId(this.data);
        addIndustryProductDiscount.setEan(ean);
        addIndustryProductDiscount.setUserDiscount(userDiscount);
        addIndustryProductDiscount.setDirectDiscount(directDiscount);
        addIndustryProductDiscount.setIndirectDiscount(indirectDiscount);

        await this.industryDiscountsService.AddIndustryProductDiscount(addIndustryProductDiscount);
        this.closeDialog();
        this.emitAddIndustryProductEvent(addIndustryProductDiscount);
      } else {
        this.toast.showWarningToast("Preencha as informações corretamente.");
      }
    } catch (error) {
      this.toast.showWarningToast(error);
    } finally {
      loadingRef.closeLoading();
    }
  }

  public navigateToEdit(industryFiscalNumber: string): void {
    this.router.navigate([RoutePath.EditLpm, industryFiscalNumber]);
  }
}
